/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Provider_OpenrouterInputs */

const en_byoa_provider_openrouter = /** @type {(inputs: Byoa_Provider_OpenrouterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenRouter`)
};

const id_byoa_provider_openrouter = /** @type {(inputs: Byoa_Provider_OpenrouterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenRouter`)
};

/**
* | output |
* | --- |
* | "OpenRouter" |
*
* @param {Byoa_Provider_OpenrouterInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_provider_openrouter = /** @type {((inputs?: Byoa_Provider_OpenrouterInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Provider_OpenrouterInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_provider_openrouter(inputs)
	return en_byoa_provider_openrouter(inputs)
});